import { createClient } from '@supabase/supabase-js';

// The single shared Supabase client. Import it as
//   import { supabase } from '@/api/supabaseClient'
//
// Both values below are public by design: the anon key is a client credential
// whose reach is bounded by row level security, not a secret. The service role
// key must never appear in this bundle.
const url = import.meta.env.VITE_SUPABASE_URL;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!url || !anonKey) {
  throw new Error(
    'Missing VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY. ' +
    'Copy .env.example to .env.local and fill both in.'
  );
}

export const supabase = createClient(url, anonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    // The OAuth and password-recovery redirects both come back with the token
    // in the URL fragment; let the SDK consume it and clean the address bar.
    detectSessionInUrl: true,
    flowType: 'pkce',
  },
});
